import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import $api from '../api'
import { GetListDTO } from '../dto'
import { CreatePlaylistDTO, Playlist } from './playlistsSlice'
import { CreateFolderDTO, EditFolderDTO, GetFoldersListDto, PlaylistFolder } from './moodsSlice'

type DaytimeId = string
interface State {
  daytimes: Record<DaytimeId, PlaylistFolder>
}

export const initialState: State = {
  daytimes: {},
}
export const attemptCreateDaytime = createAsyncThunk<PlaylistFolder, CreateFolderDTO>(
  'daytimes/daytime-create',
  async (payload) => {
    const response = await $api.post(`daytimes/create`, payload)
    return response.data
  },
)

export const attemptGetDaytimesList = createAsyncThunk<PlaylistFolder[], GetFoldersListDto>(
  'daytimes/list',
  async (payload) => {
    const response = await $api.post('daytimes/admin/list', payload)
    return response.data
  },
)

export const attemptGetDaytime = createAsyncThunk<PlaylistFolder, string>(
  'daytimes/get-daytime',
  async (id) => {
    const response = await $api.post(`daytimes/get/${id}`)

    return response.data
  },
)

export const attemptEditDaytime = createAsyncThunk<void, EditFolderDTO>(
  'daytimes/daytime-edit',
  async (payload) => {
    const response = await $api.post(`daytimes/update/${payload._id}`, payload)
    return
  },
)

export const attemptDeleteDaytime = createAsyncThunk<
  PlaylistFolder['_id'],
  PlaylistFolder['_id']
>('daytimes/daytime-delete', async (id) => {
  await $api.post(`daytimes/delete/${id}`)
  return id
})

export const daytimesReducer = createSlice({
  name: 'daytimes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(attemptCreateDaytime.fulfilled, (state, { payload }) => {
      // state.daytimes[payload._id] = payload //don't need it as we are always fetching daytimes when coming to the page
    })
    builder.addCase(attemptGetDaytimesList.fulfilled, (state, { payload }) => {
      payload.forEach((playlist) => {
        state.daytimes[playlist._id] = playlist
      })
    })
    builder.addCase(attemptDeleteDaytime.fulfilled, (state, { payload: _id }) => {
      delete state.daytimes[_id]
    })
  },
})

export const {} = daytimesReducer.actions
export default daytimesReducer.reducer
